import React, { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import styles from "../styles/styles";
import ProfileSideBar from "../components/Profile/ProfileSidebar";
import { loadUser } from "../redux/actions/user";
import { ADVERTISE_EVENT_FORM_ID, CREATE_EVENT_PATH } from "../utils/advertiseEventLink";

const ProfilePage = () => {
  const mainContentRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);

  // Always try to load user data when component mounts (only once)
  useEffect(() => {
    dispatch(loadUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array - only run once on mount

  // Redirect to login if not authenticated (after loading check)
  useEffect(() => {
    // Only redirect if loading is complete and user is not authenticated
    if (loading === false && !isAuthenticated && !user) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, user, loading, navigate]);

  // Redirect to overview if on base /profile route
  useEffect(() => {
    if (location.pathname === "/profile") {
      navigate("/profile/overview", { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (typeof window === "undefined" || window.innerWidth >= 1024) return;
    const fromSidebarClick = sessionStorage.getItem("dashboardScrollToContent") === "1";
    const isOrderDetailRoute = /^\/profile\/(?:seller-order|order)\/[^/]+$/.test(
      location.pathname
    );
    if (!fromSidebarClick && !isOrderDetailRoute) return;
    const timer = window.setTimeout(() => {
      mainContentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      if (fromSidebarClick) {
        sessionStorage.removeItem("dashboardScrollToContent");
      }
    }, 120);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (typeof window === "undefined" || window.innerWidth >= 1024) return;
    if (location.hash !== `#${ADVERTISE_EVENT_FORM_ID}`) return;
    if (!location.pathname.includes(CREATE_EVENT_PATH)) return;

    const scrollToEventForm = () => {
      mainContentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      document.getElementById(ADVERTISE_EVENT_FORM_ID)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };

    const timers = [100, 350, 700].map((ms) => window.setTimeout(scrollToEventForm, ms));
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen ">
      <Header />
      <main
        className={`${styles.section} relative flex flex-col gap-6 py-10 lg:grid lg:grid-cols-[330px,1fr] lg:items-start`}
      >
        <div className="lg:sticky lg:top-24">
          <ProfileSideBar />
        </div>
        <div className="flex-1" ref={mainContentRef}>
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProfilePage;